import { MessageTypes } from "@tmi/types/enums/message-types";
import { Unauthorized } from "@tmi/types/api/responses";
import { useAuthStore } from "@/stores/Auth";
import { storeToRefs } from "pinia";
import pinia from "@/plugins/PiniaPlugin";

export type DataSyncEvent = {
    typeSignifier: string,
    eventType: MessageTypes,
    authToken?: string | undefined | null,
    payload?: string | undefined
}

export function createDataSyncEvent( evtType: MessageTypes,
                                     payload?: string | undefined,
                                     authToken?: string | undefined ): DataSyncEvent {
    const { isAuthenticated, authToken: jwt } = storeToRefs( useAuthStore( pinia ) );
    if ( !isAuthenticated.value ) {
        throw new Unauthorized();
    }

    const token: string | null = authToken ?? jwt.value;

    return {
        typeSignifier: 'tmi_sync_evt',
        authToken: token,
        eventType: evtType,
        payload: payload
    };
}
